import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { CheckCircle2, Clock, TrendingUp } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const ContactForm = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    toast({
      title: "Message Sent Successfully!",
      description: "We'll contact you within 24 hours.",
    });
    setFormData({ fullName: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contact-form" className="py-20 bg-gray-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl text-gray-400">
              Let's discuss your project and create the perfect AI solution for your business.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <Input
                  type="text"
                  name="fullName"
                  placeholder="Full Name *"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="bg-gray-800 border-gray-600 text-white placeholder:text-gray-500 h-12"
                />
              </div>
              <div>
                <Input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="bg-gray-800 border-gray-600 text-white placeholder:text-gray-500 h-12"
                />
              </div>
            </div>
            <div>
              <Input
                type="tel"
                name="phone"
                placeholder="Phone Number *"
                value={formData.phone}
                onChange={handleChange}
                required
                className="bg-gray-800 border-gray-600 text-white placeholder:text-gray-500 h-12"
              />
            </div>
            <div>
              <Textarea
                name="message"
                placeholder="Tell us about your project *"
                value={formData.message}
                onChange={handleChange}
                required
                rows={5}
                className="bg-gray-800 border-gray-600 text-white placeholder:text-gray-500"
              />
            </div>
            <Button type="submit" size="lg" className="w-full bg-orange-600 hover:bg-orange-700 text-white py-6 text-lg">
              Send Message
            </Button>
          </form>

          <div className="grid md:grid-cols-3 gap-6 mt-8 pt-8 border-t border-gray-700">
            <div className="text-center">
              <CheckCircle2 className="w-8 h-8 text-green-400 mx-auto mb-2" />
              <p className="text-white font-semibold mb-1">Free Consultation</p>
              <p className="text-gray-400 text-sm">No obligations or hidden fees</p>
            </div>
            <div className="text-center">
              <Clock className="w-8 h-8 text-orange-400 mx-auto mb-2" />
              <p className="text-white font-semibold mb-1">24hr Response</p>
              <p className="text-gray-400 text-sm">Quick turnaround guaranteed</p>
            </div>
            <div className="text-center">
              <TrendingUp className="w-8 h-8 text-amber-400 mx-auto mb-2" />
              <p className="text-white font-semibold mb-1">Limited Slots Available</p>
              <p className="text-gray-400 text-sm">Book your spot today</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;